// helper functions
// TODO: come up with a better way to fomat currency value
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
})

export function r(value:any, format:any = {}) {
  if (typeof value === 'boolean') {
    return (value ? 'Yes' : 'No')
  }
  if (format['style'] == 'currency') {
    return formatter.format(value)
  }
  return value
}
